import { Box, Typography } from '@mui/material';
import React from 'react';
import FormAutocomplete from '../../../../../shared/FormAutocomplete';
import CustomInputLabel from '../../../../../../layout/styledcomponents/CustomInputLabel';
import moment from 'moment';

type Props = {
    control: any;
    experienceType: string;
    checkinT?: string;
    checkoutT?: string;
    checkinTime?: string;
    checkoutTime?: string;
    compareCheckinSettings: any[];
    compareCheckoutSettings: any[];
    checkoutError?: string;
    disabled?: boolean;
};

const formatTimeWithAmPm = (t?: string) => {
    const raw = String(t ?? '').trim();
    if (!raw) return '';
    const m = moment(
        raw,
        ['H:mm', 'HH:mm', 'h:mm A', 'h:mma', 'hh:mm A'],
        true,
    );
    return m.isValid() ? m.format('h:mm A') : raw;
};

export default function TimeSelectors({
    control,
    experienceType,
    checkinT,
    checkoutT,
    compareCheckinSettings,
    compareCheckoutSettings,
    checkoutError,
}: Props) {
    const isVehicle = experienceType === 'vehicle';
    const checkinLabel = formatTimeWithAmPm(checkinT);
    const checkoutLabel = formatTimeWithAmPm(checkoutT);
    return (
        <>
            <Box>
                <Box
                    display='flex'
                    alignItems='center'
                    justifyContent='space-between'
                    gap={1}
                    width='100%'
                >
                    <CustomInputLabel htmlFor='checkin-time__input'>
                        {isVehicle
                            ? 'Expected Pickup Time'
                            : 'Expected Arrival Time'}
                    </CustomInputLabel>
                    {checkinLabel ? (
                        <Typography
                            variant='body3'
                            fontSize='11px'
                            sx={{ color: 'text.secondary', flexShrink: 0 }}
                        >
                            (From: {checkinLabel})
                        </Typography>
                    ) : null}
                </Box>
                <FormAutocomplete
                    id='checkin-time__input'
                    name='bookingInfo.checkinTime'
                    control={control}
                    options={compareCheckinSettings}
                />
            </Box>

            <Box>
                <Box
                    display='flex'
                    alignItems='center'
                    justifyContent='space-between'
                    gap={1}
                    width='100%'
                >
                    <CustomInputLabel htmlFor='checkout-time__input'>
                        {isVehicle
                            ? 'Expected Dropoff Time'
                            : 'Expected Departure Time'}
                    </CustomInputLabel>
                    {checkoutLabel ? (
                        <Typography
                            variant='body3'
                            fontSize='11px'
                            sx={{ color: 'text.secondary', flexShrink: 0 }}
                        >
                            (Before: {checkoutLabel})
                        </Typography>
                    ) : null}
                </Box>
                <FormAutocomplete
                    id='checkout-time__input'
                    name='bookingInfo.checkoutTime'
                    control={control}
                    options={compareCheckoutSettings}
                    customError={checkoutError}
                />
            </Box>
        </>
    );
}
